module.exports = __webpack_public_path__ + "img/chapter__10_image_5.e0b30a77.jpg";